import StatusLabel from "~/components/StatusLabel";
import {Button, Table, Tag} from "antd";
import {
	renderDate,
	numberFormat
} from "~/utils";
import {useDevice} from "~/hooks";
import {useContext} from "react";
import {AppContext} from "~/context/AppProvider";

function CommitTable({items, onDetail, onModalOpen}) {

	const {tableHeight} = useContext(AppContext);

	const {isMobile} = useDevice();

	const onClickDetail = (item) => {
		onDetail(item.id);
		onModalOpen('detail')
	}

	let columns = [
		{ title: 'Phòng', dataIndex: 'groupName', key: "groupName", width: '200px', render: (_, item) => (
			<div>{item.name}</div>
		)},
		{ title: 'Cam kết ngày', dataIndex: 'day', key: "day", width: '200px', render: (_, item) => (
			<div>
				{(item.day.time?.length === 0) && <StatusLabel small type="red">Chưa có cam kết</StatusLabel>}
				{(item.day.time?.length !== 0) && <>
					<Tag color="green">{numberFormat(item.day.commit)}</Tag>
					<p className="color-grey text-xs mt-1">{item.day.time}</p>
				</>}
			</div>
		)},
		{ title: 'Doanh số ngày', dataIndex: 'revenueDay', key: "revenueDay", width: '100px', render: (_, item) => (
			<p><b>{numberFormat(item?.day.revenue)}</b></p>
		)},
		{ title: 'Đạt', dataIndex: 'percentDay', key: "percentDay", width: '80px', render: (_, item) => (
			<div>
				<p className="d-flex gap justify-content-between">
					{(item.day.percent >= 0 && item.day.percent <= 50) &&
						<StatusLabel small type="red">{item.day.percent}%</StatusLabel>}
					{(item.day.percent > 50) && <StatusLabel small type="green">{item.day.percent}%</StatusLabel>}
				</p>
			</div>
		)},
		{ title: 'Cam kết tháng', dataIndex: 'month', key: "month", width: '100px', render: (_, item) => (
			<div>
				{(item.month.time?.length === 0) && <StatusLabel small type="red">Chưa có cam kết</StatusLabel>}
				{(item.month.time?.length !== 0) && <>
					<Tag color="green">{numberFormat(item.month.commit)}</Tag>
					<p className="color-grey text-xs mt-1">{item.month.time}</p>
				</>}
			</div>
		)},
		{ title: 'Danh số tháng', dataIndex: 'revenueMonth', key: "revenueMonth", width: '80px', render: (_, item) => (
			<p><b>{numberFormat(item?.month.revenue)}</b></p>
		)},
		{ title: 'Đạt', dataIndex: 'percentMonth', key: "percentMonth", width: '180px', render: (_, item) => (
			<div>
				<p className="d-flex gap justify-content-between">
					{(item.month.percent <= 50) && <StatusLabel small type="red">{item.month.percent}%</StatusLabel>}
					{(item.month.percent > 50) && <StatusLabel small type="green">{item.month.percent}%</StatusLabel>}
				</p>
			</div>
		)},
		{ title: '#', dataIndex: 'action', key: "action", width: '180px', render: (_, item) => (
			<div>
				<Button type="primary" onClick={() => onClickDetail(item)}>Chi tiết</Button>
			</div>
		)},
	];

	const dataSource= items.map(row => ({
		key: row.id, // I added this line
		...row
	}));

	return (
		<div className="table-wrapper">
			<div className="table-box">
				<Table columns={columns} dataSource={dataSource} scroll={{ y:tableHeight, x: 'max-content' }} pagination={false} />
			</div>
		</div>
	)
}

export default CommitTable;